import { useContext } from 'react';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
export const useTour = () => {
  const {
    tour
  } = useContext(TourContext);
  return tour;
};
export const useDismissStep = (dismissAndDeactivate = true) => {
  const tour = useTour();
  return step => {
    if (!tour.getHandler().isActive) {
      return;
    }
    const steps = tour.getConfig().steps;
    const stepKey = step || tour.getStep();
    const nextStepIndex = steps.indexOf(stepKey) + 1;
    if (nextStepIndex < steps.length) {
      const nextStep = steps[nextStepIndex];
      tour.next(nextStep);
    } else {
      tour.next();
    }
    if (dismissAndDeactivate) {
      tour.deactivate();
    }
  };
};